<template lang="pug">
.would-you-like-to(v-if="hasVisibleBlocks")
  h2 Would you like to add...
  p Please specify the desired option.
  .would-you-like-to-blocks.flex-rows.flex-wrap
    template(v-for="block in visibleBlocks")
      block(:key="block.route" :data="block" @before-route="$emit('before-route')")
</template>

<script>
import Block from './block'

import ProductsMixin from '../../_mixins/products'
const mixins = [ProductsMixin]

export default {
  name: 'would-you-like-to',
  settings: 'element.would-you-like-to',
  translations: 'element.would-you-like-to',
  mixins,
  props: {
    settings: {},
    translations: {},
    exclude: {
      type: String,
      default: null,
    },
  },

  components: {
    Block,
  },
  computed: {
    hasVisibleBlocks() {
      return !!this.visibleBlocks.length
    },
    visibleBlocks() {
      return this.BLOCKS.filter(block => block.route !== this.exclude)
    },
    BLOCKS() {
      const blocks = this.getFilteredWouldYouLikeBlocks()
      return this.translateProductName(blocks, ['title', 'message'])
    }
  },
}
</script>

<style lang="scss">
.would-you-like-to {
  > h2 {
    line-height: 37px;
    font-size: 30px;
    margin-bottom: 0;
  }
  @media(max-width: 846px) {
    margin-left: 16px;
    margin-right: 16px;
  }
  @media(max-width: 569px) {
    .would-you-like-to-blocks {
      justify-content: space-around;
    }
  }
}
</style>
